import React, { forwardRef } from 'react'
import { InputNumber } from '@ow/comps'

export default forwardRef(({ opts = {}, value, style, onChange }, ref) => {
  const { max, min } = opts
  return (
    <InputNumber
      ref={ref}
      {...opts}
      style={{
        height: '100%',
        width: '132px',
        ...style,
        paddingLeft: 'none',
      }}
      className="right-input"
      max={max || 9999999999}
      min={min || 0}
      placeholder={opts.hint || `请输入${opts.title}`}
      onChange={onChange}
      value={value}
    />
  )
})
